import { cn } from '@cointracker/styleguide';
import { buttonVariants } from '@cointracker/styleguide/src/LoggedIn';
import { useTranslation } from 'react-i18next';
import { Integration } from 'src/types/graphql-types';
import { Instructions } from '../Instructions';
import { IntegrationFormModalFooter } from '../IntegrationFormModalFooter';
interface PartnerRedirectFormProps {
  integration: Integration;
  redirectLink: string;
}

export const PartnerRedirectForm = (props: PartnerRedirectFormProps) => {
  const integration = props.integration;
  const { t } = useTranslation();
  return (
    <>
      <Instructions integration={integration} showCSVInstructions={false} />
      <IntegrationFormModalFooter>
        <a
          href={props.redirectLink}
          className={cn(buttonVariants({ variant: 'primary', size: 'large' }))}
        >
          {t('add_wallet_modal.partner_redirect_form.continue_with', {
            integrationName: integration.name,
          })}
        </a>
      </IntegrationFormModalFooter>
    </>
  );
};
